require('./availPromotionBox.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const classnames = require('classnames');

// @actions
const advancedInterstitialPromotionActions = require('actions/advancedInterstitialPromotions');

//@commons
const { EmptyState } = require('commonsComponents/emptyState');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { recordLink } = require('utilities/tagging');

//@constants
const {
    ADVANCED_INTERSTITIAL_CONTINUE_WITHOUT_PROMOTION_EVENT_ACTION,
    ADVANCED_INTERSTITIAL_SIGN_UP_EVENT_ACTION
} = require('constants/index');

class AvailPromotionBox extends React.Component {

    handleRedirect(immAdvancedInterstitialPromotions) {
        recordLink(immAdvancedInterstitialPromotions.getIn(['promotions', 'nid']), ADVANCED_INTERSTITIAL_SIGN_UP_EVENT_ACTION)
        this.props.history.push('/myprofile/promotions/hireAdvInterstitialPromotion');
    }

    render() {
        const {
            alreadyUpdated,
            getAdvancedInterstitialPromotions,
            immAdvancedInterstitialPromotions,
            promotionAlreadyAvailed,
        } = this.props;

        const retryButton = (
            <OKButton onClick={()=>getAdvancedInterstitialPromotions()}>
                <FormattedText value="common-retry" />
            </OKButton>
        );

        let footerContent;
        let promotionBoxContent;
        if (!!immAdvancedInterstitialPromotions) {
            if (immAdvancedInterstitialPromotions.get('isFetching')) {
                promotionBoxContent = <LoadingSection />
            } else if (immAdvancedInterstitialPromotions.get('error')) {
                promotionBoxContent = (
                    <div className="avail-promotion-box__empty-state">
                        <EmptyState
                            button={retryButton}
                            iconType="nointernet-banking"
                            primaryText={formatText('availPromotionSuccessStep-availPromotionSuccessStep_errorState')}
                        />
                    </div>
                );
            }  else if(immAdvancedInterstitialPromotions.get('noContent')){
                promotionBoxContent = (
                    <div className="avail-promotion-box__empty-state">
                        <EmptyState
                            button={retryButton}
                            iconType="noitems-banking"
                            primaryText={formatText('availPromotionSuccessStep-availPromotionSuccessStep_emptyStateTitle')}
                        />
                    </div>
                );
            } else if (immAdvancedInterstitialPromotions.get('success')) {
                const immPromotions = immAdvancedInterstitialPromotions.get('promotions');
                const descriptionClasses = classnames('avail-promotion-box__description', {
                    'avail-promotion-box__already-availed-description': promotionAlreadyAvailed,
                });
                const promoBoxClasses = classnames('avail-promotion-box__container', 'row', {
                    'avail-promotion-box__already-updated-container': alreadyUpdated
                });
                const imageCMSURL = immPromotions.get('imageURL');
                let tagValue;

                if (promotionAlreadyAvailed) {
                    tagValue = (
                        <div className="avail-promotion-box__tag">
                            <FormattedText value="availPromotionSuccessStep-availPromotionSuccessStep_alreadyAvailedTagText"/>
                        </div>
                    );
                } else {
                    const secondaryCTAURL = alreadyUpdated ? '/myprofile/global' : '/myprofile/edit';
                    footerContent = (
                        <footer className="avail-promotion-box__details-footer">
                            <div className="avail-promotion-box__details-footer-bases-link">
                                <OKLink
                                    modifier="ghost"
                                    to={secondaryCTAURL}
                                    onClick={() => recordLink(immAdvancedInterstitialPromotions.getIn(['promotions', 'nid']), ADVANCED_INTERSTITIAL_CONTINUE_WITHOUT_PROMOTION_EVENT_ACTION)}
                                >
                                    <FormattedText value="availPromotionSuccessStep-availPromotionSuccessStep_secondaryCTAText" />
                                </OKLink>
                            </div>
                            <div className="avail-promotion-box__details-footer-refer-button pull-right">
                                <OKButton id="availPromotionLink"
                                    modifier="secondary"
                                    onClick={() => this.handleRedirect(immAdvancedInterstitialPromotions)}
                                >
                                    <FormattedText value="availPromotionSuccessStep-availPromotionSuccessStep_primaryCTAText" />
                                </OKButton>
                            </div>
                        </footer>
                    );
                }

                promotionBoxContent = (
                    <div className={promoBoxClasses}>
                        <div className="col-xs-4 avail-promotion-box__wrapper-image">
                            <img src={imageCMSURL} className="avail-promotion-box__image" />
                            <div className="avail-promotion-box__tag-wrapper">{tagValue}</div>
                        </div>
                        <div className="col-xs-8 avail-promotion-box__details">
                            <HTMLSafeInjector
                                customClass={descriptionClasses}
                                message={immPromotions.get('description')}
                            />
                            {footerContent}
                        </div>
                    </div>
                );
            }
        }

        return (
            <section className="avail-promotion-box__promo-section">
                {promotionBoxContent}
            </section>
        )
    }
}

AvailPromotionBox.propTypes = {
    alreadyUpdated: PropTypes.bool,
    getAdvancedInterstitialPromotions: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAdvancedInterstitialPromotions: PropTypes.object,
    promotionAlreadyAvailed: PropTypes.bool.isRequired,
};

module.exports.constructor = AvailPromotionBox;
module.exports.AvailPromotionBox = connect(
    state => ({
        immAdvancedInterstitialPromotions: state.advancedInterstitialPromotions
    }),
    {
        getAdvancedInterstitialPromotions: advancedInterstitialPromotionActions.getAdvancedInterstitialPromotions,
    }
)(withRouter(AvailPromotionBox));
